module.exports = __webpack_public_path__ + "static/media/1.82b9a4bf.JPG";